import * as React from "react";

export function MemberOptionsSkeleton() {
  return (
    <div className="mt-[16px] animate-pulse">
      <div className="flex items-center justify-between gap-[16px]">
        <div className="h-[22px] w-1/3 max-w-[220px] rounded-[8px] bg-divider" />
        <div className="flex items-center gap-[16px]">
          <div className="hidden sm:block h-[16px] w-[80px] rounded-[8px] bg-divider" />
          <div className="flex items-center gap-[10px]">
            <div className="h-[32px] w-[90px] sm:w-[110px] rounded-[999px] bg-divider" />
            <div className="hidden sm:block h-[32px] w-[90px] rounded-[999px] bg-divider" />
            <div className="hidden sm:block h-[32px] w-[110px] rounded-[999px] bg-divider" />
          </div>
        </div>
      </div>

      <div className="mt-[16px] rounded-[16px] bg-surface border border-divider overflow-x-auto">
        <div className="min-w-full">
          <div className="grid grid-cols-7 gap-[12px] px-[16px] py-[14px]">
            <div className="h-[12px] w-1/2 rounded-[6px] bg-divider" />
            <div className="h-[12px] w-4/5 rounded-[6px] bg-divider" />
            <div className="h-[12px] w-2/3 rounded-[6px] bg-divider" />
            <div className="h-[12px] w-2/3 rounded-[6px] bg-divider" />
            <div className="h-[12px] w-3/4 rounded-[6px] bg-divider" />
            <div className="h-[12px] w-2/3 rounded-[6px] bg-divider" />
            <div className="h-[12px] w-3/4 rounded-[6px] bg-divider" />
          </div>

          <div className="space-y-[10px] px-[16px] pb-[16px]">
            {Array.from({ length: 6 }).map((_, i) => (
              <div
                key={i}
                className="grid grid-cols-7 gap-[12px] items-center rounded-[12px] bg-secondary/30 px-[12px] py-[14px]"
              >
                <div className="h-[12px] w-1/3 rounded-[6px] bg-divider" />
                <div className="space-y-[8px]">
                  <div className="h-[12px] w-4/5 rounded-[6px] bg-divider" />
                  <div className="h-[10px] w-3/5 rounded-[6px] bg-divider" />
                </div>
                <div className="h-[12px] w-2/3 rounded-[6px] bg-divider" />
                <div className="h-[12px] w-2/3 rounded-[6px] bg-divider" />
                <div className="h-[12px] w-3/4 rounded-[6px] bg-divider" />
                <div className="h-[12px] w-1/2 rounded-[6px] bg-divider" />
                <div className="h-[32px] w-3/4 rounded-[10px] bg-divider" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

